import {
  ChangeDetectorRef,
  Injectable,
  OnDestroy,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { getMessage, Language, MessageID } from '@rivethealth/data/translation';
import { Subscription } from 'rxjs';
import { TranslationService } from './translation.service';

@Injectable()
@Pipe({
  name: 'translate',
  pure: false, // required for cdr.markForCheck to have effect
})
export class TranslatePipe implements PipeTransform, OnDestroy {
  constructor(
    cdr: ChangeDetectorRef,
    private readonly translationService: TranslationService,
  ) {
    this.subscription = this.translationService.lang.subscribe(lang => {
      this.lang = lang;
      cdr.markForCheck();
    });
  }

  subscription: Subscription;
  lang: Language = 'en';

  transform(id: MessageID, ...args: (string | null)[]) {
    return getMessage(id, this.lang, ...(args || []));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
